// 预病历暂存的 localStorage key 前缀
// 实际存储 key 结构：PRE_MEDICAL_RECORD_DRAFT:doctorId:patientId:daUserId
export const PRE_MEDICAL_RECORD_DRAFT_KEY_PREFIX = 'PRE_MEDICAL_RECORD_DRAFT'

// 暂存有效期（30天，毫秒）
export const PRE_MEDICAL_RECORD_DRAFT_TTL = 30 * 24 * 60 * 60 * 1000

// 根据医生、患者、健管用户拼接唯一 key，避免不同对象之间互相覆盖
export const getPreMedicalDraftKey = ({ doctorId, patientId, daUserId }) =>
  `${PRE_MEDICAL_RECORD_DRAFT_KEY_PREFIX}:${doctorId || ''}:${patientId || ''}:${daUserId || ''}`

// 判断一条暂存是否应该被清除：
// 1) 结构非法
// 2) expiresAt 缺失或不是有效数字
// 3) 已经过期
const shouldRemoveDraft = draft => {
  if (!draft || typeof draft !== 'object') {
    return true
  }
  if (!draft.expiresAt || Number.isNaN(Number(draft.expiresAt))) {
    return true
  }
  return Date.now() > Number(draft.expiresAt)
}

// 全局清理入口：扫描当前 localStorage 中所有预病历暂存 key，
// 删除过期数据和异常数据（例如 JSON 破损），并返回删除数量。
export const clearExpiredPreMedicalDrafts = () => {
  // SSR 或非浏览器环境兜底
  if (typeof window === 'undefined' || !window.localStorage) {
    return 0
  }
  const storage = window.localStorage
  const prefix = `${PRE_MEDICAL_RECORD_DRAFT_KEY_PREFIX}:`
  const keys = []

  // 先收集 key，再删除，避免遍历 storage 时边删边遍历导致索引错乱
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i)
    if (key && key.startsWith(prefix)) {
      keys.push(key)
    }
  }

  let removedCount = 0
  keys.forEach(key => {
    const draftText = storage.getItem(key)
    if (!draftText) {
      // key 存在但 value 为空，也视为脏数据
      storage.removeItem(key)
      removedCount += 1
      return
    }
    try {
      const draft = JSON.parse(draftText)
      if (shouldRemoveDraft(draft)) {
        storage.removeItem(key)
        removedCount += 1
      }
    } catch (error) {
      // JSON 解析失败，说明数据损坏，直接清理
      storage.removeItem(key)
      removedCount += 1
    }
  })

  return removedCount
}
